import React, { useState, useEffect, useCallback } from 'react';
import { Tabs } from 'antd';

import { CarouselImage } from '../../../components/CarouselImage';
import { TabMotorista } from './TabMotorista';
import { TabVeiculos } from './TabVeiculos';
import { TabConsultas } from './TabConsultas';
import { TabAnotacoes } from './TabAnotacoes';
import { TabViagem } from './TabViagem';

import * as S from '../styles';

export function TabsBox({
  solicitacao,
  tipoSolicitacao,
  imgsMotorista = [],
  imgsVeiculo = [],
  carregarSolicitacaoAtual,
  setSpinning = { setSpinning },
  setObservacaoInterna,
  observacaoInterna,
}) {
  const [tabImgVeiculos, setTabImgVeiculos] = useState([]);
  const [tabImgMotorista, setImgMotorista] = useState([]);
  const [imgMotoristaIndex, setImgMotoristaIndex] = useState(0);
  const [imgVeiculoIndex, setImgVeiculoIndex] = useState(0);
  const [activeTabState, setActiveTabState] = useState('1');
  const [active, setActive] = useState(activeTabState);

  const updateActiveTab = useCallback(tabKey => setActiveTabState(tabKey), []);

  useEffect(() => {
    setActive(activeTabState);
  }, [activeTabState, tabImgMotorista, tabImgVeiculos]);

  const onChange = isActived => {
    setActive(isActived);
    updateActiveTab(isActived);
  };

  const onClose = targetKey => {
    if (targetKey === '2') {
      setImgMotorista([]);
      updateActiveTab('1');
    }
    if (targetKey === '3') {
      setTabImgVeiculos([]);
      updateActiveTab('1');
    }
  };

  const isOpenTabMotoristaImgs = (imgs = []) => {
    setActiveTabState('2');
    return setImgMotorista(imgs);
  };

  const isOpenTabVeiculoImgs = (imgs = []) => {
    setActiveTabState('3');
    return setTabImgVeiculos(imgs);
  };

  const dadosItems = [
    {
      key: '1',
      label: 'Motorista',
      children: (
        <S.TabContent>
          <TabMotorista
            data={solicitacao?.motorista}
            imagens={imgsMotorista}
            spinningImg={!imgsMotorista?.length}
            openTab={isOpenTabMotoristaImgs}
            indexImgMotorista={setImgMotoristaIndex}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            tipoValidacao={tipoSolicitacao}
          />
        </S.TabContent>
      ),
    },
    {
      key: '2',
      label: 'Veículos',
      children: (
        <S.TabContent>
          <TabVeiculos
            imgsVeiculo={imgsVeiculo}
            openTabe={isOpenTabVeiculoImgs}
            indexImgVeiculo={setImgVeiculoIndex}
            spinningImg={!imgsVeiculo?.length}
            solicitacao={solicitacao}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            tipoValidacao={tipoSolicitacao}
          />
        </S.TabContent>
      ),
    },
    {
      key: '3',
      label: 'Anotações',
      children: (
        <S.TabContent>
          <TabAnotacoes
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            ultimaAtualizacaoObservacaoInterna={
              solicitacao?.ultimaAtualizacaoObservacaoInterna
            }
            setObservacaoInterna={setObservacaoInterna}
            observacaoInterna={observacaoInterna}
          />
        </S.TabContent>
      ),
    },
    solicitacao?.detalhesViagem && {
      key: '4',
      label: 'Viagem',
      children: (
        <S.TabContent>
          <TabViagem detalhesViagem={solicitacao.detalhesViagem} />
        </S.TabContent>
      ),
    },
  ].filter(Boolean);

  const consultasItems = [
    {
      key: '1',
      label: 'Consultas',
      closable: false,
      children: (
        <S.TabContent className="consultas">
          <TabConsultas
            data={solicitacao}
            tipoSolicitacao={tipoSolicitacao}
            observacaoInterna={observacaoInterna}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          />
        </S.TabContent>
      ),
    },
    tabImgMotorista?.length > 0 && {
      key: '2',
      label: 'Documentos Motorista',
      children: (
        <S.TabContent className="consultas">
          <CarouselImage
            data={tabImgMotorista}
            indexImg={imgMotoristaIndex}
            titulo="Documentos motorista"
          />
        </S.TabContent>
      ),
    },
    tabImgVeiculos?.length > 0 && {
      key: '3',
      label: 'Documentos Veículo',
      children: (
        <S.TabContent className="consultas">
          <CarouselImage
            data={tabImgVeiculos}
            indexImg={imgVeiculoIndex}
            titulo="Documentos veículo"
          />
        </S.TabContent>
      ),
    },
  ].filter(Boolean);

  return (
    <>
      <S.TabsColumn>
        <S.CardTabs>
          <Tabs type="card" defaultActiveKey="1" items={dadosItems} />
        </S.CardTabs>
      </S.TabsColumn>
      <S.TabsColumn>
        <S.CardTabs>
          <Tabs
            type="editable-card"
            activeKey={active}
            hideAdd
            onChange={onChange}
            onEdit={onClose}
            items={consultasItems}
          />
        </S.CardTabs>
      </S.TabsColumn>
    </>
  );
}
